export const DeliveryAssetsConfigModel = {
	model: [
		{
			label: 'Provider',
			key: 'provider'
		},
		{
			label: 'Event Source',
			key: 'eventSource'
		},
		{
			label: 'Product',
			key: 'productName',
		},
		{
			label: 'Client',
			key: 'clientName',
		},
		{
			label: 'Updated',
			key: 'updated',
		},
		{
			label: 'Updated By',
			key: 'updatedBy',
		},
	],
	callBacks: {
		onRowEditInit: (row: any, model: any, extraData: any) => {
			if (row.trackingSystem === 'Acuity') {
				model[3].options = extraData.acuityOptions;
			} else {
				model[3].options = extraData.appScopeOptions;
			}
		}
	},
	formBuilderConfig: {
		provider: {
			DataType: 'Selector',
			UIControl: 'Dropdown',
			DisplayText: 'Provider',
			Name: 'provider',
			options: [],
			UIOptions: {
				ShowClearButton: true
			}
		},
		eventSource: {
			DataType: 'Selector',
			UIControl: 'Dropdown',
			DisplayText: 'Event Source',
			Name: 'eventSource',
			options: [],
			UIOptions: {
				ShowClearButton: true
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					model['productId'].options = [];
					if ($event.value) {
						const trackingSystemOptionsName = $event.value[0].toLowerCase() + $event.value.substring(1);
						model['client'].disabled = false;
						model['productId'].options = extraData[trackingSystemOptionsName];
						model['client'].UIOptions.Url = `${extraData.rootUrl}/utils/${$event.value.toLowerCase()}/lenders`
					} else {
						model['client'].disabled = true;
						model['client'].UIOptions.Url = ``;
						model['productId'].options = [];
					}

					if (formGroup && formGroup.get('client')) {
						formGroup.get('client')?.setValue(null);
						formGroup.get('clientName')?.setValue(null);
						formGroup.get('clientId')?.setValue(null);

						if ($event.value) {
							formGroup.get('client')?.enable();
						} else {
							formGroup.get('client')?.disable();
						}
					}

					if (formGroup && formGroup.get('productId')) {
						formGroup.get('productId')?.setValue(null);
						formGroup.get('productName')?.setValue(null);
					}

				}
			}
		},
		client: {
			DataType: 'Selector',
			DisplayText: 'Client',
			Name: 'client',
			UIControl: 'Autocomplete',
			disabled: true,
			required: false,
			UIOptions: {
				Url: '',
				OptionsMapper: {
					id: 'id',
					name: 'title'
				},
				Mapper: {
					id: 'clientId',
					name: 'clientName'
				},
				FilterName: 'title'
			},
			UIEvents: {
				onSelect: ($event: any, formGroup: any, model?: any) => {
					if ($event) {
						formGroup.get('clientName').setValue($event?.name);
						formGroup.get('clientId').setValue($event?.id);
					}
				},
				onClear: ($event: any, formGroup: any) => {
					formGroup?.get('client')?.setValue(null);
					formGroup?.get('clientName')?.setValue(null);
					formGroup?.get('clientId')?.setValue(null);
				}
			}
		},
		productId: {
			DataType: 'Selector',
			UIControl: 'Dropdown',
			DisplayText: 'Product',
			Name: 'productId',
			required: false,
			options: [],
			UIOptions: {
				ShowClearButton: true
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					let selectedValue = [];
					if (formGroup) {
						const eventSource = formGroup.get('eventSource')?.value;

						if (eventSource) {
							const trackingSystemOptionsName = eventSource[0].toLowerCase() + eventSource.substring(1);
							selectedValue = extraData[trackingSystemOptionsName]?.filter((option: any) => option.value === $event.value);
						}

						if (selectedValue?.length) {
							//formGroup.get('productId')?.setValue(selectedValue[0].value);
							formGroup.get('productName')?.setValue(selectedValue[0].label);
						}

					}
				}
			}
		},
		deliveryAssets: {
			path: 'deliveryAssets',
			DataType: 'Array',
			DisplayText: 'Documents',
			ButtonText: 'Add new Document',
			child: [],
			childFormBuilderConfig: {
				source: {
					DataType: 'Selector',
					UIControl: 'Dropdown',
					DisplayText: 'Source',
					Name: 'source',
					options: [],
					UIOptions: {
						ShowClearButton: true
					},
					UIEvents: {
						onChange: ($event: any, model: any, formGroup: any, extraData: any, fieldOptions?: any) => {
							if (model) {
								model['deliveryAssets']['child'][fieldOptions.index]['documentType'].options = [];
								model['deliveryAssets']['child'][fieldOptions.index]['documentType'].options = extraData.deliveryAssets[$event.value.toLowerCase()]
								model['deliveryAssets']['child'][fieldOptions.index]['documentType'].disabled = false;
							}


							const formArray = formGroup?.get('deliveryAssets');
							if (formGroup && formArray && formArray.at(fieldOptions.index)?.get('documentType')) {
								if ($event.value) {
									formArray.at(fieldOptions.index).get('documentType').enable();
								} else {
									formArray.at(fieldOptions.index).get('documentType').disable();
									formArray.at(fieldOptions.index).get('documentType')?.setValue(null);
								}
							}
						}
					}
				},
				documentType: {
					DataType: 'Selector',
					DisplayText: 'Document Type',
					Name: 'documentType',
					UIControl: 'Dropdown',
					disabled: true,
					options: [],
					UIOptions: {
						ShowClearButton: true,
						OptionsMapper: {
							id: 'id',
							name: 'title'
						}
					},
					UIEvents: {
						onSelect: ($event: any, formGroup: any, model?: any) => {
							//
						}
					}
				},
				required: {
					DataType: 'Selector',
					UIControl: 'Dropdown',
					DisplayText: 'Required',
					defaultValue: false,
					options: [
						{
							'label': 'Yes',
							'value': true
						},
						{
							'label': 'No',
							'value': false
						}
					],
					Name: 'required',
					required: true,
					UIOptions: {
						ShowClearButton: true
					}
				}
			}
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'id',
			hidden: true,
			required: false
		},
		productName: {
			DataType: 'String',
			DisplayText: 'productName',
			Name: 'productName',
			hidden: true,
			required: false
		},
		clientId: {
			DataType: 'String',
			DisplayText: 'clientId',
			Name: 'clientId',
			hidden: true,
			required: false
		},
		clientName: {
			DataType: 'String',
			DisplayText: 'clientName',
			Name: 'clientName',
			hidden: true,
			required: false
		}
	}
}
